<template>
  <div>
    <p class="menu-label" style="margin: 10px">Add a {{ this.type }}</p>
    <!-- If adding course -->
    <div v-if="isShowingSubjects && isCourse">
      <div class="searchBox">
        <p class="coursesFont">Enter the course code</p>
        <p class="coursesFont" style="font-size: 13px; margin: 0px">
          {{ this.exampleCourseCode }}
        </p>
        <input
          placeholder="Course Code"
          type="text"
          class="searchBar"
          v-model="courseSearch"
        />
        <button @click="findCourse" class="searchButton">Enter</button>
        <p>{{ this.searchFeedback }}</p>

        <li v-if="searchedCourse != null">
          <button class="plusButton" @click="addGroup(searchedCourse)">
            {{ searchedCourse.name }}
          </button>
        </li>
      </div>
    </div>

    <div v-if="isShowingSubjects">
      <ul class="addList">
        <li v-for="subject in subjects" :key="subject.id">
          <button
            class="plusButton"
            @click="handleSubjectClicked(subject.name)"
          >
            {{ subject.name }}
          </button>
        </li>
      </ul>
    </div>

    <div v-if="!isShowingSubjects && !isShowingSubjectsForCreatingGroup">
      <ul class="addList">
        <li v-for="group in groups" :key="group.id">
          <button class="plusButton" @click="addGroup(group)">
            {{ getGroupName(group) }}
          </button>
        </li>
      </ul>
    </div>

    <div v-if="isShowingGroupTypes">
      <!-- Displays the courses for the user to add -->
      <ul class="addList">
        <p style="margin: 15px">Choose a Group type</p>

        <li v-for="type in groupTypes" :key="type.id">
          <button class="plusButton" @click="showGroups(type)">
            {{ type }}
          </button>
        </li>
      </ul>
    </div>

    <!-- If is creating group -->
    <div v-if="isCreating" style="padding: 15px">
      <p>Create a new group by entering its name</p>

      <input
        style="margin-bottom: 1em; width: 100px; margin: 10px"
        v-model="groupName"
        class="input is-focused"
        type="text"
        placeholder="Name"
      />

      <!-- Cancel button -->
      <button @click="isCreating = false" class="delButton2 is-danger"></button>

      <p class="feedback">{{ this.feedback }}</p>

      <div>
        Type: {{ this.selectedGroupType }}
        <button
          @click="isShowingCreateGroupTypes = true"
          class="currentGroupType is-success"
        >
          (change)
        </button>
      </div>
      <div v-if="isShowingSubjectsForCreatingGroup">
        <ul class="addList">
          <li v-for="subject in subjects" :key="subject.id">
            <button
              class="plusButton"
              @click="handleSubjectClicked(subject.name)"
            >
              {{ subject.name }}
            </button>
          </li>
        </ul>
      </div>
      <div
        style="height: 200px; overflow: auto"
        v-if="isShowingCreateGroupTypes"
      >
        <!-- Displays the courses for the user to add -->
        <ul class="addList">
          <li v-for="type in groupTypes" :key="type.id">
            <button class="plusButton" @click="setSelectedGroupType(type)">
              {{ type }}
            </button>
          </li>
        </ul>
      </div>

      <!-- Create group button -->
      <button
        v-if="isCreating"
        @click="createGroup()"
        class="createButton is-success"
      >
        Create Group
      </button>
    </div>
    <div v-if="isGroup && !isCreating" style="padding: 15px">
      <p>Don't see the group you're looking for?</p>
      <button @click="setIsCreating" class="createButton is-success">
        Create Group
      </button>
    </div>
    <h3 class="feedback">{{ this.alreadyAddedMessage }}</h3>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import db from "@/db";
import firebase from "@/firebase";
export default {
  mounted() {
    //this.init();
    this.setExampleCourseCode();
  },

  data: () => ({
    groups: [],
    groupName: "",
    type: "",
    exampleCourseCode: "",
    courseSearch: "",
    feedback: "", //If the user enters a course that already exitst is shows a message
    alreadyAddedMessage: "", //if the user has already added that course or faculty
    searchTerm: "",
    searchFeedback: "",
    groupTypes: [
      "General",
      "Course Related",
      "Club",
      "Intramural",
      "Study Group",
    ],
    selectedGroupType: "General",
    subject: "",
    subjects: [],
    searchedCourse: null,
    isShowingCreateGroupTypes: false,
    isShowingSubjectsForCreatingGroup: false,
    isShowingSubjectsForAddingGroup: false,
  }),

  computed: {
    ...mapState("groups", [
      "isEditing",
      "isAdding",
      "isCreating",
      "isCourse",
      "isFaculty",
      "isGroup",
      "isShowingSubjects",
      "isShowingGroupTypes",
    ]),
    ...mapState("user", ["user"]),
  },

  methods: {
    ...mapActions("groupInfo", ["getGroupIdType", "getGroupsFromType"]),
    ...mapActions("messageBoard", ["subscribeToTopic"]),
    ...mapActions("user", ["updateUserGroups"]),
    ...mapActions("groups", [
      "fetchCourses",
      "fetchSubjects",
      "fetchFaculties",
      "fetchGroups",
      "fetchGroupsForSubject",
    ]),

    async init() {
      if (this.isShowingSubjects) {
        this.type = "Course";
        this.subjects = await this.fetchSubjects(this.user.school_id);
      } else if (this.isFaculty) {
        this.groups = await this.fetchFaculties(this.user.school_id);
      } else {
        this.type = "Group";
      }
    },

    setExampleCourseCode() {
      if (this.user.school_id == "pOFdIKe2KVcQ8IbEl6sw") {
        this.exampleCourseCode = "Ex: ANATOMY AND CELL BIOLOGY 3200A/B";
      } else if (this.user.school_id == "5Uo24jSg4nGg3sVOzeec") {
        this.exampleCourseCode = "Ex: ACCT 362";
      } else if (this.user.school_id == "ZP4XckEioy7tqvjebFYa") {
        this.exampleCourseCode = "Ex: ADMN-1221H";
      }
    },

    async addGroup(group) {
      if (await this.getGroupsFromType({ group: group.id, user: this.user })) {
        this.alreadyAddedMessage = "You have already added this group";
        return;
      }

      if (this.isCourse) {
        this.user.courses.push({
          name: group.name,
          id: group.id,
          unreadPosts: true,
          lastVisited: Date.now(),
          notificationsEnabled: true,
        });
        this.user.course_ids.push(group.id);
        this.incrementGroupCount("courses", group.id);
      } else if (this.isFaculty) {
        this.user.faculties.push({
          name: group.name,
          id: group.id,
          unreadPosts: true,
          lastVisited: Date.now(),
          notificationsEnabled: true,
        });
        this.user.faculty_ids.push(group.id);
        this.incrementGroupCount("faculties", group.id);
      } else {
        this.user.groups.push({
          name: group.name,
          id: group.id,
          unreadPosts: true,
          lastVisited: Date.now(),
          notificationsEnabled: true,
        });
        this.user.group_ids.push(group.id);
        this.incrementGroupCount("groups", group.id);
      }

      this.$store.commit("user/setUser", this.user);
      this.updateUserGroups();
      this.subscribeToTopic({ groupId: group.id, user: this.user });

      var joinedContent =
        this.user.firstName + " " + this.user.lastName + " joined the group";

      this.addUserJoinedGroupPost(joinedContent, group);

      this.$store.commit("messageBoard/setGroupId", group.id);
      this.$router.push({
        name: "MessageBoard",
        params: {
          name: this.getGroupName(group).replace(/\s/g, ""),
        },
      });

      this.reset();
    },

    getGroupName(group) {
      return group.name;
    },

    incrementGroupCount(groupType, id) {
      db.collection(groupType)
        .doc(id)
        .update({
          userCount: firebase.firestore.FieldValue.increment(1),
        });
    },

    addUserJoinedGroupPost(content, group) {
      db.collection("posts").add({
        content: content,
        chat_id: group.id,
        created_at: Date.now(),
      });
    },

    async findCourse() {
      db.collection("courses")
        .where("school_id", "==", this.user.school_id)
        .where("name", "==", this.courseSearch.toUpperCase())
        .get()
        .then((querySnapshot) => {
          this.searchFeedback = "";

          if (querySnapshot.size > 0) {
            querySnapshot.forEach((doc) => {
              if (doc.data()) {
                this.searchedCourse = doc.data();
                this.searchedCourse.id = doc.ref.id;
              }
            });
          } else {
            this.searchFeedback =
              "This course does not exist, make sure you entered the exact course code";
          }
        });
    },

    async setSelectedGroupType(type) {
      this.isShowingCreateGroupTypes = false;
      if (type === "Course Related") {
        this.isShowingSubjectsForCreatingGroup = true;
        if (this.subjects.length == 0) {
          this.subjects = await this.fetchSubjects(this.user.school_id);
        }
      }
      this.selectedGroupType = type;
    },

    //Shows all courses from the users school
    async showCourses(subject) {
      this.subject = subject;
      this.$store.commit("groups/setIsShowingSubjects", false);
      var info = {
        school_id: this.user.school_id,
        subject: subject,
      };

      this.groups = await this.fetchCourses(info);
    },

    async showFaculties() {
      this.groups = this.fetchFaculties(this.user.school_id);
    },

    async showGroups(type) {
      this.$store.commit("groups/setIsShowingGroupTypes", false);
      this.selectedGroupType = type;
      var dbType = this.getGroupType();
      if (dbType == "course") {
        this.$store.commit("groups/setIsShowingSubjects", true);
        this.isShowingSubjectsForAddingGroup = true;
        if (this.subjects.length == 0) {
          this.subjects = await this.fetchSubjects(this.user.school_id);
          console.log(this.subjects);
        }
        return;
      }

      var info = {
        school_id: this.user.school_id,
        type: dbType,
      };
      this.groups = await this.fetchGroups(info);
    },

    setIsCreating() {
      if (this.selectedGroupType === "Course Related") {
        this.$store.commit("groups/setIsShowingSubjects", true);
      }
      this.$store.commit("groups/setIsCreating", true);
    },

    async createGroup() {
      if (this.groupName.length < 5) {
        this.feedback = "Group name must be between 5 and 30 characters";
        return;
      }
      db.collection("groups")
        .where("name", "==", this.groupName)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.feedback = "A group has already been created with that name";
            return;
          } else {
            var dbType = this.getGroupType();
            var subject = "";
            if (dbType == "course") {
              subject = this.subject;
            }

            var group = {
              userCount: 0,
              school_id: this.user.school_id,
              name: this.groupName,
              subject: subject,
              type: dbType,
              profileImage:
                "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/originalChat.png?alt=media&token=b2ab8f4a-83f7-44cc-960b-f7590a5a162c",
            };
            db.collection("groups")
              .add({
                userCount: 0,
                school_id: this.user.school_id,
                name: this.groupName,
                subject: subject,
                type: dbType,
              })
              .then((docRef) => {
                group.id = docRef.id;
                this.addGroup(group);
              });
            this.feedback = "";
            this.reset();
          }
        });
    },

    getGroupType() {
      switch (this.selectedGroupType) {
        case "General":
          return "general";
        case "studyGroup":
          return "studyGroup";
        case "Club":
          return "club";
        case "Intramural":
          return "intramural";
        default:
          return "course";
      }
    },

    async handleSubjectClicked(subject) {
      if (this.isCourse) {
        this.showCourses(subject);
      } else {
        if (this.isCreating) {
          this.selectedGroupType = subject;
        } else {
          this.groups = await this.fetchGroupsForSubject({
            subject: subject,
            school_id: this.user.school_id,
          });
        }
      }

      this.$store.commit("groups/setIsShowingSubjects", false);
    },

    reset() {
      this.groups = [];
      this.selectedGroupType = "General";
      this.isShowingCreateGroupTypes = false;
      this.isShowingSubjectsForCreatingGroup = false;
      this.$emit("reset");
    },
  },
};
</script>
